import React, {useMemo} from 'react';
import {ArrowDownTrayIcon, PhotoIcon, TrashIcon} from "@heroicons/react/24/outline";
import {http} from "../utils/http";
import ButtonLink from "./ButtonLink";
import Button from "./Button";
import Loading from "./Loading";
import {cn} from "../utils/style";
import {toast} from "react-toastify";

function FileInput({
                       name,
                       label,
                       id,
                       get,
                       set,
                       required = false,
                       disk = 'local',
                       allowedFileTypes = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif', 'bmp', 'tiff', 'tif']
                   }) {
    const [uploading, setUploading] = React.useState(false);
    const handleFileUpload = async (event) => {
        setUploading(true);
        try {
            const file = event.target.files[0];
            if (!file) return;

            // Validate file type
            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (!allowedFileTypes.includes(fileExtension)) {
                toast.error(`Invalid file type. Allowed types: ${allowedFileTypes.join(', ')}`);
                set(null);
                setUploading(false);
                return;
            }

            const formData = new FormData();
            formData.append('file', file);
            formData.append('disk', disk ?? 'local');
            const response = await http.post('/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const {fileUrl, fileName, mimeType} = response?.data;
            if (fileUrl) {
                set({fileUrl, fileName, mimeType});
            }
        } catch (error) {
            console.error(error);
            toast.error('Error uploading file. Please try again.');
            set(null);
        }
        setUploading(false);
    }

    return (
        <div className={cn("sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-4")}>
            <label
                htmlFor={name}
                className='flex flex-col gap-3 text-sm font-medium leading-6 text-gray-900 sm:pt-1.5'
            >
                <div>
                    {label}{' '}
                    <span className='text-red-500/50 text-[10px]' aria-label='Required'>
						{required ? '(Required)' : ''}
					</span>
                </div>
            </label>
            <div className="relative mt-2 sm:col-span-2 sm:mt-0 overflow-hidden">
                {uploading && <div
                    className="backdrop-blur-sm z-40 w-full h-full absolute top-0 left-0 bg-white/20 flex justify-center items-center">
                    <Loading message="Uploading ..."/>
                </div>}

                {get?.fileUrl && <div>
                    {/*<div className="mb-1 overflow-x-auto">*/}
                    {/*    <p className="text-sm text-gray-500 font-mono leading-6 tracking-tight">*/}
                    {/*        {get?.fileName}*/}
                    {/*    </p>*/}
                    {/*</div>*/}
                    <div className="flex gap-3 items-center">
                        {/*<ButtonLink href={get?.fileUrl} target="_blank" className="flex items-center justify-center gap-2">*/}
                        {/*    <ArrowDownTrayIcon className="h-4 w-4 text-white"/>*/}
                        {/*    <span>Download</span>*/}
                        {/*</ButtonLink>*/}
                        <Button secondary={true} onClick={() => set(null)}
                                className="flex items-center justify-center gap-2">
                            <TrashIcon className="h-4 w-4 text-white"/>
                            <span>Clear</span>
                        </Button>
                    </div>
                </div>}

                {!get?.fileUrl && <div
                    className="flex max-w-2xl justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10 bg-white">
                    <div className="text-center">
                        <PhotoIcon className="mx-auto h-12 w-12 text-gray-300" aria-hidden="true"/>
                        <div className="mt-4 xl:flex text-sm leading-6 text-gray-600">
                            <label
                                htmlFor={id}
                                className="relative cursor-pointer rounded-md bg-white font-semibold text--blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring--blue-500 focus-within:ring-offset-2 hover:text-indigo-500"
                            >
                                <span>Upload a file</span>
                                <input id={id} name={name} onChange={handleFileUpload}
                                       type="file" className="sr-only"/>
                            </label>
                            <p className="pl-1">or drag and drop</p>
                        </div>
                        <p className="text-xs leading-5 text-gray-600">{allowedFileTypes.map(type => type.toUpperCase()).join(', ')} up
                            to 10MB</p>
                    </div>
                </div>}
            </div>
        </div>
    );
}

export default FileInput;
